module.exports = {
      id: "step-1-usage",
      viewBox: "0 0 86 85",
      url: __webpack_public_path__ + "img/icons.91580017.svg#step-1-usage",
      toString: function () {
        return this.url;
      }
    }